{
	"page": {
		"title": "Para classes",
		"intro": "The sport classes of the ASEAN Para Games — S9, T11, BC3 — each owned by one sport. An event lists the <strong>classes</strong> it is open to, and an athlete competes in one.",
		"addSportClass": "Add para class",
		"building": "This page is being built.",
		"count_one": "{{n}} para class",
		"count_other": "{{n}} para classes"
	},
	"filters": {
		"gamesLabel": "Games",
		"sportLabel": "Sport",
		"pickGamesFirst": "Pick a games first",
		"searchPlaceholder": "Search para classes by code or name",
		"searchSports": "Search sports"
	},
	"table": {
		"code": "Code",
		"name": "Name",
		"sport": "Sport",
		"events": "Events",
		"eventsTitle": "Events open to this class",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} para class",
		"summary_other": "{{from}}–{{to}} of {{total}} para classes",
		"empty": "No para classes"
	},
	"empty": {
		"filteredTitle": "No para classes match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No para classes yet",
		"noneDescription": "Add the classes of each para sport.",
		"clearFilters": "Clear filters"
	},
	"form": {
		"addTitle": "Add para class",
		"addDescription": "A class of one sport. Events open to it, and athletes competing in it, use it as a class of that sport.",
		"addSubmit": "Add para class",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} event is open to this class — a code change shows on it immediately.",
		"editInUse_other": "{{count}} events are open to this class — a code change shows on them immediately.",
		"editEmpty": "No events are open to this class yet.",
		"section": {
			"identity": "Identity",
			"identityHint": "The sport the class belongs to, and how it reads on start lists."
		},
		"field": {
			"sport": "Sport",
			"sportHint": "A class belongs to one sport and cannot move.",
			"code": "Code",
			"codeHint": "Like S9, T11 or BC3. Stored in capitals.",
			"name": "Name",
			"nameHint": "Optional — a description of the class."
		},
		"placeholder": {
			"sport": "Pick a sport",
			"code": "S9",
			"name": "Swimming, physical impairment"
		}
	},
	"delete": {
		"title": "Delete para class",
		"description": "Delete <strong>{{name}}</strong>? This only works while no event is open to it and no athlete competes in it.",
		"confirm": "Delete para class",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete para class"
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add para class",
		"updateFailed": "Couldn't update para class"
	},
	"errors": {
		"codeTaken": "That class already exists in this sport.",
		"sportRequired": "Pick a sport",
		"sportMissing": "That sport no longer exists.",
		"inUse": "Events or athletes still use this class.",
		"invalidValue": "Invalid value"
	},
	"sort": {
		"sportAsc": "Sport, programme order",
		"sportDesc": "Sport, reversed"
	},
	"stats": {
		"total": "Para classes",
		"matching": "matching the filters",
		"inGames": "In this games"
	}
}
